import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import Image from "next/image";
import { useScrollIntoView } from "@mantine/hooks";
import { FAQTabsProps } from "@/components/pages/faq/FAQ";
import { addBasePathToStrapiMedia, formatStrapiEntity } from "@/utils/strapi";
import { useMountEffect } from "@/hooks/useMountEffect";
import styles from "./FAQMenu.module.scss";

type AccountMenuProps = {
  selectedTab: number;
  setSelectedTab: Dispatch<SetStateAction<number>>;
  tabs: FAQTabsProps[];
};

export const FAQMenu = ({
  selectedTab,
  setSelectedTab,
  tabs,
}: AccountMenuProps) => {
  const { scrollIntoView, targetRef, scrollableRef } =
    useScrollIntoView<HTMLDivElement>({
      axis: "x",
    });

  const changeTab = (tab: number) => {
    setSelectedTab(tab);
    setTimeout(() => {
      scrollIntoView({ alignment: "center" });
    }, 100);
  };

  useMountEffect(() => setSelectedTab(0));

  return (
    <div className={styles.menu}>
      <div className={styles.menuContent}>
        <div className={styles.menuTabs} ref={scrollableRef}>
          {tabs.map((tab: FAQTabsProps, index: number) => {
            const strapiImage = formatStrapiEntity(tab.icon);

            return (
              <div className={styles.scrollableTabs} key={index}>
                <div
                  className={classNames(styles.menuTab, {
                    [styles.selectedMenuTab]: selectedTab === index,
                  })}
                  onClick={() => changeTab(index)}
                  ref={selectedTab === index ? targetRef : undefined}
                >
                  <div className={styles.menuTabIconContainer}>
                    <div className={styles.menuTabIcon}>
                      <Image
                        src={addBasePathToStrapiMedia(strapiImage)}
                        objectFit="contain"
                        objectPosition="center"
                        alt={strapiImage.alternativeText ?? ""}
                        layout="fill"
                      />
                    </div>
                  </div>
                  <div className={styles.menuTabLabel}>{tab.title}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
